var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesignWorkNeeded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.96 148.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#7da2fe;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-3,.cls-4{stroke-width:2px;}.cls-3{fill:none;}.cls-4{fill:#1e83f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1,107.09V5.98C1,3.23,3.23,1,5.98,1H173.98c2.75,0,4.98,2.23,4.98,4.98V107.09H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1,121.08v-13.99H178.96v13.99c0,2.75-2.24,4.98-4.98,4.98H5.98c-2.75,0-4.98-2.23-4.98-4.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.44,
    y: 113.68,
    width: 15.09,
    height: 27.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62.73,
    y: 141.2,
    width: 54.51,
    height: 6.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1,121.08v-13.99H178.96v13.99c0,2.75-2.24,4.98-4.98,4.98H5.98c-2.75,0-4.98-2.23-4.98-4.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.36,
    y: 97.69,
    width: 46.25,
    height: 10.92,
    transform: "translate(297.83 -9.84) rotate(108.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.24,125.33h1.93c1.4,0,2.53,1.13,2.53,2.53v5.86c0,1.4-1.13,2.53-2.53,2.53h-1.93v-10.92h0Z",
    transform: "translate(312.3 34.93) rotate(108.06)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "164.1 67.53 166 79.32 155.61 75.94 164.1 67.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.95,66.85s1.8,6.74-4.95,8.07c-8.15,1.6-8.48-6.62-5.86-10.7,2.89-4.49,.86-6.95,.86-6.95,0,0,8.64,2.91,9.95,9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.25,72.78c.18-.12,1.54-1.12,1.86-3.27,.28-1.91-.48-3.33-.62-3.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.65,81.88l.05,.35,7.44,48.22c.31,1.57-.79,3.1-2.45,3.43-1.67,.33-3.27-.68-3.58-2.24l-11.39-47.45-.08-.35c-.51-2.6,1.32-5.15,4.08-5.69,2.76-.54,5.42,1.12,5.93,3.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.34,147.24h-26.58l-5.99-46.76c-.27-2.14,1.39-4.03,3.55-4.03h31.45c2.16,0,3.82,1.89,3.55,4.03l-5.99,46.76Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignWorkNeeded);
export default __webpack_public_path__ + "static/media/design-work-needed.38fe5f4fb007010362549a5302d805dc.svg";
export { ForwardRef as ReactComponent };